import { Box, Paper, Tab, Tabs } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';

import { PersitedDatePicker } from '../../../components/common';
import { AddButton } from '../../../components/common/button/CustomButtons';
import ModalCustom from '../../../components/common/Modal';
import { SupervisorPartTable } from '../../../components/ui';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import Summary from './components/dashboard/summary/Summary';
import Type from './components/dashboard/typeOfComplaint/Type';
import DefectWise from './components/dashboard/defectwise/DefectWise';
const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};

const CustomerConcernDashboardTabs = () => {
  const { state } = useAuth();
  const { user } = state;
  const date = useQuery('date') || '';
  const [tabValue, setTabValue] = useState(0);
  const [tableData, setTableData] = useState<any[]>([]);
  const [render, setRender] = useState(false);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [data, setData] = useState({
    dashBoardMonthCounts: [],
    totalOfMonth: {},
  });
  const [type, setType] = useState({
    totalOfDomesticPerMonth: {},
    totalOfExportsPerMonth: {},
  });
  const [defects, setDefects] = useState({
    defectsCountResult: [],
    defectsCountColumnResult: { TotalColumn: [] },
    defectsName: [],
  });
  const [year, setYear] = useState(0);

  const fetchData = async () => {
    if (date) {
      if (tabValue == 0) {
        const res = await axios
          .get(`/api/customerConcernRoutes/getByMonth/?date=${date}`)
          .catch((err) => {
            console.log(err);
          });

        setData(res?.data);
        setYear(new Date(date).getFullYear());
      } else if (tabValue == 1) {
        const res = await axios
          .get(`/api/customerConcernRoutes/getByTypeOfComplaint/?date=${date}`)
          .catch((err) => {
            console.log(err);
          });

        setType(res?.data);
        setYear(new Date(date).getFullYear());
      } else {
        const res = await axios
          .get(`/api/customerConcernRoutes/getByDefects/?date=${date}`)
          .catch((err) => {
            console.log(err);
          });
        console.log('res', res);
        setDefects(res?.data);
        setYear(new Date(date).getFullYear());
      }
    }
    //setPerPage(res?.data?.perPage);
    //setTotalPages(res?.data?.pages);
  };
  useEffect(() => {
    fetchData();
  }, [date, tabValue]);
  console.log('data', data);
  /*useEffect(() => {
    // fetch data here
    let userType = '';
    if (state.user?.userType === 2) {
      userType = 'admin';
    } else {
      userType = 'supervisor';
    }
    axios
      .get(`/api/pir/monthly/${userType}/${date}`)
      .then((res) => {
        if (res.data) setTableData(res.data);
      })
      .catch((err) => console.log(err));
  }, [render, date]);*/

  /*const deleteDocument = async (id: string) => {
    let isDeleted = window.confirm(
      'Are you sure you want to delete this document?'
    );
    if (isDeleted) {
      axios
        .delete(`/api/pir/${id}`)
        .then(() => {
          alert('document deleted successfully');
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }
  };

  const updateStatus = async (id: string, documentIndex: number) => {
    let isConfirm = window.confirm('Are you sure you want to update status');
    if (isConfirm && tableData.length > 0) {
      axios
        .patch(`/api/pir/updateStatus/${id}`, {
          is_admin_request_no: tableData[documentIndex].is_admin_request_no,
          report_approved_by: state.user?.name,
        })
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Status Change successfully');
          }
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleChangeStatus = (
    e: React.ChangeEvent<HTMLSelectElement>,
    documentIndex: number
  ) => {
    const values = [...tableData];
    values[documentIndex].is_admin_request = null;
    values[documentIndex].is_admin_request_no = e.target.value;
    setTableData(values);
  };*/
  console.log('year', year);
  console.log('defects', defects);
  return (
    <Box>
      <ChildHeader text="CUSTOMER CONCERN DASHBOARD"></ChildHeader>
      <Paper elevation={2}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          indicatorColor="primary"
          scrollButtons="auto"
          textColor="secondary"
          variant="fullWidth"
        >
          <Tab label="Summary" />
          <Tab label="Domestic Vs Exports" />
          <Tab label="DefectWise New" />
        </Tabs>
      </Paper>
      <Box sx={{ margin: 2 }}>
        <PersitedDatePicker label="Search By Year" views={['year']} />
      </Box>
      {
        <section>
          {tabValue === 0 && (
            <Summary apiData={data} year={year} /*{...{ annualDate }} */ />
          )}
          {tabValue === 1 && <Type apiData={type} year={year} />}
          {tabValue === 2 && <DefectWise apiData={defects} year={year} />}
        </section>
      }
    </Box>
  );
};

export default CustomerConcernDashboardTabs;
